import { useIsAuthenticated, useMsal } from '@azure/msal-react';
import { loginRequest } from './msalConfig';
import { DEV_BYPASS_AUTH } from './authFetch';

const DEV_USER = { username: 'info@ai-evora.com', name: 'Local Developer' };

export function useAuth() {
  const { instance, accounts } = useMsal();
  const isAuthenticated = useIsAuthenticated();
  const account = accounts[0] ?? null;

  if (DEV_BYPASS_AUTH) {
    return {
      user: DEV_USER,
      email: DEV_USER.username,
      name: DEV_USER.name,
      isAuthenticated: true,
      login: () => {},
      logout: () => {},
    };
  }

  const login = () => instance.loginRedirect(loginRequest);
  const logout = () =>
    instance.logoutRedirect({
      account,
      postLogoutRedirectUri: window.location.origin,
    });

  return {
    user: account,
    email: account?.username ?? '',
    name: account?.name ?? '',
    isAuthenticated,
    login,
    logout,
  };
}
